/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule, HEADER_CONFIG } from './app/app.module';
import { ENVIRONMENT_CONFIG, EnvironmentConfiguration } from './environments/models/environment.model';
import { LIBRARY_CONFIG } from '@gea/digital-ui-lib';

void fetch('./assets/environment-config.json')
  .then((resp) => resp.json())
  .then((config: EnvironmentConfiguration) => {
    if (config.production) {
      enableProdMode();
    }
    platformBrowserDynamic([
      { provide: ENVIRONMENT_CONFIG, useValue: config },
      {
        provide: HEADER_CONFIG,
        useValue: {
          redirectUri: config.oAuth.redirectURL,
          postLogoutRedirectUri: config.oAuth.postLogoutRedirectURL,
          clientId: config.oAuth.clientId,
          authority: config.oAuth.authority,
          authorityDomain: config.oAuth.authorityDomain,
          portalURL: config.portal.redirectURL,
          authConfigUrls: new Map().set(`${config.endpoint}*`, ['openid', 'offline_access', 'email', config.oAuth.clientId]),
        },
      },
      {
        provide: LIBRARY_CONFIG,
        useValue: { baseUrl: config.baseURL, redirectUri: config.oAuth.redirectURL, iconStorageURL: config.iconStorageURL },
      },
      {
        provide: Window,
        useValue: window,
      },
    ])
      .bootstrapModule(AppModule)
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  });
